// @flow
const genres = {
	action: `פעולה`,
	animation: `אנימציה`,
	adventure: `הרפתקאות`,
	biography: 'ביוגרפיה',
	children: `ילדים`,
	comedy: `קומדיה`,
	crime: `פשע`,
	documentary: `דוקומנטרי`,
	drama: `דרמה`,
	family: `משפחה`,
	fantasy: `פנטזיה`,
	gameshow: 'שעשועון',
	'game-show': `שעשועון`,
	history: 'היסטוריה',
	'home and garden': `בית וגן`,
	horror: `אימה`,
	'mini-series': `מיני סדרה`,
	mystery: `מסתורין`,
	musical: `מחזמר`,
	news: `חדשותי`,
	reality: `ריאליטי`,
	'reality-tv': `ריאליטי`,
	romance: `רומנטיקה`,
	'sci-fi': 'מדע בדיוני',
	'special interest': `מיוחד`,
	sport: `ספורט`,
	suspense: `מותחן`,
	thriller: `מתח`,
	music: `מוזיקלי`,
	war: `מלחמתי`,
	'talk-show': `אירוח`,
	short: `קצר`,
	western: `מערבון`,
};

export const genreHeb = (genreEng: string): string => {
	if (!genreEng) {
		return '';
	}

	return genres[genreEng.toLowerCase()] || genreEng;
};
